import React, { useMemo, useState, useEffect ,  useContext, useRef } from 'react';
import pt from 'prop-types';
import cn from 'classnames';
import styles from './MultiPose.module.scss';
import sheetStyles from '../../_pages/Holiday/Builder/HolidayBuilder.module.scss'
import PreviewImage from '../../PreviewImage';
import previewImageStyles from '../../PreviewImage/PreviewImage.module.sass';
import useImageOrientation, { ORIENTATION } from '../../../hooks/useImageOrientation';
import {
  stripImageTypeName,
  getNumImgsPerSheetByName,
} from './functions';
import { SheetPropType } from './PropTypes';
import MultiPoseComponent from './MultiPoseComponent';
import ornamentPlaceholder from "../../_pages/Holiday/Builder/assets/ornament-placeholder.png";
import cardPlaceholder from "../../_pages/Holiday/Builder/assets/card-placeholder.png";
import Image from "../../Image";
import blackImage from '../../../assets/PromoImage_Slide_1_Black.jpg';

import plaidBackground from '../../../assets/Senior_Grey.jpg';
import SchoolAnnouncementThumbnail from '../../_pages/Holiday/Builder/SchoolAnnouncementThumbnail';
import { CURSIVE_BASE_URL, CURSIVE_OVERLAY_URL as cursiveForeground } from '../../_pages/Holiday/Builder/announcementThumbnail';
import { CustomerContext } from '../../../contexts/CustomerContext';
import reportUnknownAddonVariant from '../../../utils/addonPreviewVariant';
import axios from 'axios';
import '../../../fonts/fonts.scss'; 

export default function DisplayableSheet({ inBuilder = false, children, sheets = [], setSheets = () => { }, className, sheet, inPreview = false }) {
  const nameWithoutNum = useMemo(() => stripImageTypeName(sheet.imageType), [sheet.imageTypeId]);
  const numImgsPerSheet = useMemo(() => getNumImgsPerSheetByName(nameWithoutNum, inPreview), [nameWithoutNum, inPreview]);

  // Measured orientation of the pose driving the sheet. Called unconditionally here
  // (before any early return) so hook order stays stable. Consumed by the 5x7/3x5 combo
  // layout AND the default print-cell sizing below; undefined until the image loads, so
  // both default to the portrait arrangement and switch when a LANDSCAPE source resolves.
  const poseOrientation = useImageOrientation(sheet?.pose?.watermarkUrl || sheet?.pose?.imageUrl).orientation;

  // Add function to determine the classname based on the image type name
  const getImageTypeClassname = useMemo(() => {
    console.log('DEBUG: nameWithoutNum:', nameWithoutNum);
    console.log('DEBUG: sheet.imageType.classname:', sheet.imageType.classname);
    
    // More flexible pattern matching
    const nameStr = nameWithoutNum.toLowerCase();
    const hasComboPattern = (nameStr.includes('5x7') && nameStr.includes('3x5')) ||
                           (nameStr.includes('5 x 7') && nameStr.includes('3 x 5')) ||
                           nameStr.includes('combo') ||
                           nameStr.includes('mixed');
    
    if (hasComboPattern) {
      console.log('DEBUG: Matched combo pattern, returning fivebyseven2threebyfive');
      return 'fivebyseven2threebyfive';
    }
    
    console.log('DEBUG: No match, returning original classname:', sheet.imageType.classname);
    // Default to the existing classname
    return sheet.imageType.classname;
  }, [nameWithoutNum, sheet.imageType.classname]);

  if (sheet.imageType.component && sheet.imageType.classname != 'ornament') {
    return <MultiPoseComponent inBuilder={inBuilder} sheet={sheet} sheets={sheets} setSheets={setSheets} />;
  }

  const [currentImageUrl, setCurrentImageUrl] = useState(null);
  const [currentClassName, setCurrentClassName] = useState(sheetStyles.poseOneMagnet);
  const [currentClassNameposeTwoMagnet, setCurrentClassNameposeTwoMagnet] = useState(sheetStyles.poseTwoMagnet);
  const [currentClassNamecalendar, setCurrentClassNamecalendar] = useState(sheetStyles.calendar);
  const [currentClassNamecalendarweek, setCurrentClassNamecalendarweek] = useState(sheetStyles.calendarweek);
  const [currentClassNameornament, setCurrentClassNameornament] = useState(sheetStyles.ornament);
  const [currentClassNameGradAn, setCurrentClassGradAn] = useState(sheetStyles.gradannouncement);
  const [currentClassNameposeOneKeychain, setCurrentClassNameposeOneKeychain] = useState(sheetStyles.poseOneKeychain);
  const [currentClassNameeightbytenG, setCurrentClassNameeightbytenG] = useState(sheetStyles.eightbytenG);
  const [currentClassNameposeOnefivebyseven, setCurrentClassNameposeOnefivebyseven] = useState(sheetStyles.poseOnefivebyseven);
  const [currentClassNameposeTwofivebyseven, setCurrentClassNameposeTwofivebyseven] = useState(sheetStyles.poseTwofivebyseven);

  const [currentClassNameposeOnethreebyfive, setCurrentClassNameposeOnethreebyfive] = useState(sheetStyles.poseOnethreebyfive);
  const [currentClassNameposeTwothreebyfive, setCurrentClassNameposeTwothreebyfive] = useState(sheetStyles.poseTwothreebyfive);
  const [currentClassNameposeThreethreebyfive, setCurrentClassNameposeThreethreebyfive] = useState(sheetStyles.poseThreethreebyfive);
  const [currentClassNameposeFourthreebyfive, setCurrentClassNameposeFourthreebyfive] = useState(sheetStyles.poseFourthreebyfive);

  const [currentClassNameposeOneWallet, setCurrentClassNameposeOneWallet] = useState(sheetStyles.poseOneWallet);
  const [currentClassNameposeTwoWallet, setCurrentClassNameposeTwoWallet] = useState(sheetStyles.poseTwoWallet);
  const [currentClassNameposeThreeWallet, setCurrentClassNameposeThreeWallet] = useState(sheetStyles.poseThreeWallet);
  const [currentClassNameposeFourWallet, setCurrentClassNameposeFourWallet] = useState(sheetStyles.poseFourWallet);
  const [currentClassNameposeFiveWallet, setCurrentClassNameposeFiveWallet] = useState(sheetStyles.poseFiveWallet);
  const [currentClassNameposeSixWallet, setCurrentClassNameposeSixWallet] = useState(sheetStyles.poseSixWallet);
  const [currentClassNameposeSevenWallet, setCurrentClassNameposeSevenWallet] = useState(sheetStyles.poseSevenWallet);
  const [currentClassNameposeEightWallet, setCurrentClassNameposeEightWallet] = useState(sheetStyles.poseEightWallet);

  const [currentClassNameposeOnePlaque, setCurrentClassNameposeOnePlaque] = useState(sheetStyles.poseOnePlaque);

  const [currentClassNamecoffeecup, setCurrentClassNamecoffeecup] = useState(sheetStyles.coffeecup);

  useEffect(() => {
    if (!sheet?.addon) return; // Guard clause for undefined sheet or  addon
    
      if (sheet.pose?.watermarkUrl?.includes('-01.png') || sheet.pose?.watermarkUrl?.includes('-04.png') || sheet.pose?.watermarkUrl?.includes('-05.png') || sheet.pose?.watermarkUrl?.includes('-07.png')) {
        setCurrentImageUrl(sheet.addon.backImageUrl || sheet.addon.imageUrl);
      } else {
        setCurrentImageUrl(sheet.addon.imageUrl || '');
      }
    
  }, [sheet?.addon, sheet?.pose?.watermarkUrl]);
  const { customer } = useContext(CustomerContext);
  useEffect(() => {
    if (!sheet?.addon?.backImageUrl) return; // Guard clause
    
    if (currentImageUrl === sheet.addon.backImageUrl) {
      setCurrentClassName(sheetStyles.HoriztalposeOneMagnet);
      setCurrentClassNameposeTwoMagnet(sheetStyles.HoriztalposeTwoMagnet);
      setCurrentClassNamecalendar(sheetStyles.Horiztalcalendar);
      setCurrentClassNamecalendarweek(sheetStyles.Horiztalcalendarweek);
      setCurrentClassNameornament(sheetStyles.Horiztalornament);
      setCurrentClassGradAn(sheetStyles.gradannouncement);
      setCurrentClassNameposeOneKeychain(sheetStyles.HoriztalposeOneKeychain);
      setCurrentClassNameeightbytenG(sheetStyles.HoriztaleightbytenG);
      setCurrentClassNameposeOnefivebyseven(sheetStyles.HoriztalposeOnefivebyseven);
      setCurrentClassNameposeTwofivebyseven(sheetStyles.HoriztalposeTwofivebyseven);

      setCurrentClassNameposeOnethreebyfive(sheetStyles.HoriztalposeOnethreebyfive);
      setCurrentClassNameposeTwothreebyfive(sheetStyles.HoriztalposeTwothreebyfive);
      setCurrentClassNameposeThreethreebyfive(sheetStyles.HoriztalposeThreethreebyfive);
      setCurrentClassNameposeFourthreebyfive(sheetStyles.HoriztalposeFourthreebyfive);

      setCurrentClassNameposeOneWallet(sheetStyles.HoriztalposeOneWallet);
      setCurrentClassNameposeTwoWallet(sheetStyles.HoriztalposeTwoWallet);
      setCurrentClassNameposeThreeWallet(sheetStyles.HoriztalposeThreeWallet);
      setCurrentClassNameposeFourWallet(sheetStyles.HoriztalposeFourWallet);
      setCurrentClassNameposeFiveWallet(sheetStyles.HoriztalposeFiveWallet);
      setCurrentClassNameposeSixWallet(sheetStyles.HoriztalposeSixWallet);
      setCurrentClassNameposeSevenWallet(sheetStyles.HoriztalposeSevenWallet);
      setCurrentClassNameposeEightWallet(sheetStyles.HoriztalposeEightWallet);

      setCurrentClassNameposeOnePlaque(sheetStyles.HoriztalposeOnePlaque);

      setCurrentClassNamecoffeecup(sheetStyles.coffeecup);
    } else {
      setCurrentClassName(sheetStyles.poseOneMagnet);
      setCurrentClassNameposeTwoMagnet(sheetStyles.poseTwoMagnet);
      setCurrentClassNamecalendar(sheetStyles.calendar);
      setCurrentClassNamecalendarweek(sheetStyles.calendarweek);
      setCurrentClassNameornament(sheetStyles.ornament);
      setCurrentClassGradAn(sheetStyles.gradannouncement);
      setCurrentClassNameposeOneKeychain(sheetStyles.poseOneKeychain);
      setCurrentClassNameeightbytenG(sheetStyles.eightbytenG);
      setCurrentClassNameposeOnefivebyseven(sheetStyles.poseOnefivebyseven);
      setCurrentClassNameposeTwofivebyseven(sheetStyles.poseTwofivebyseven);

      setCurrentClassNameposeOnethreebyfive(sheetStyles.poseOnethreebyfive);
      setCurrentClassNameposeTwothreebyfive(sheetStyles.poseTwothreebyfive);
      setCurrentClassNameposeThreethreebyfive(sheetStyles.poseThreethreebyfive);
      setCurrentClassNameposeFourthreebyfive(sheetStyles.poseFourthreebyfive);

      setCurrentClassNameposeOneWallet(sheetStyles.poseOneWallet);
      setCurrentClassNameposeTwoWallet(sheetStyles.poseTwoWallet);
      setCurrentClassNameposeThreeWallet(sheetStyles.poseThreeWallet);
      setCurrentClassNameposeFourWallet(sheetStyles.poseFourWallet);
      setCurrentClassNameposeFiveWallet(sheetStyles.poseFiveWallet);
      setCurrentClassNameposeSixWallet(sheetStyles.poseSixWallet);
      setCurrentClassNameposeSevenWallet(sheetStyles.poseSevenWallet);
      setCurrentClassNameposeEightWallet(sheetStyles.poseEightWallet);

      setCurrentClassNameposeOnePlaque(sheetStyles.poseOnePlaque);

      setCurrentClassNamecoffeecup(sheetStyles.coffeecup);
    }
  }, [currentImageUrl, sheet?.addon?.backImageUrl]);

  // (Removed: a ResizeObserver that measured #displayable-sheet into a `componentWidth` state
  // which was never read. It was dead leftover code, and observing the sheet while the layout
  // resizes on a pose transition tripped the browser's "ResizeObserver loop completed with
  // undelivered notifications" warning, which the dev-server overlay surfaced as a fatal error.)

  const widthPerItem = useMemo(() => {
    switch (numImgsPerSheet) {
      case 1:
        return 100;
      case 2:
        return 50;
      case 4:
        return 50;
      case 8:
        return 25;
      default:
        return 50;
    }
  }, [numImgsPerSheet]);

  // Add this useEffect to DisplayableSheet.jsx to debug
useEffect(() => {
  console.log('DisplayableSheet re-rendered with sheet:', {
    id: sheet.id,
    backgroundId: sheet.backgroundId,
    background: sheet.background,
    poseId: sheet.poseId
  });
}, [sheet.id, sheet.backgroundId, sheet.background?.id, sheet.poseId]);

  const renderImageComponent = () => {
    console.log('DEBUG: renderImageComponent - getImageTypeClassname:', getImageTypeClassname);
    
    // Use the computed classname instead of sheet.imageType.classname
    switch (getImageTypeClassname) {
      case 'fivebyseven2threebyfive':
        console.log('DEBUG: Rendering combo case with 3 images');
        return (
          <div className={sheetStyles.itemImgWrapper}>
            <Image src={currentImageUrl || ''} alt="" classes={cn(sheetStyles.packageImage, previewImageStyles.img, previewImageStyles.responsive)} />
            
            {/* Large 8x10 image on the left */}
            <div className={sheetStyles.comboLargeImage} style={{border: '2px solid red'}}>
              <PreviewImage
                isResponsive
                isPreviewHidden={false}
                actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                backgroundUrl={backgroundForSheet(sheet)}
              />
            </div>
            
            {/* Top small 8x10 image on the right */}
            <div className={sheetStyles.comboSmallImageTop} style={{border: '2px solid blue'}}>
              <PreviewImage
                isResponsive
                isPreviewHidden={false}
                actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                backgroundUrl={backgroundForSheet(sheet)}
              />
            </div>
            
            {/* Bottom small 8x10 image on the right */}
            <div className={sheetStyles.comboSmallImageBottom} style={{border: '2px solid green'}}>
              <PreviewImage
                isResponsive
                isPreviewHidden={false}
                actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                backgroundUrl={backgroundForSheet(sheet)}
              />
            </div>
          </div>
        );
      case 'ornament':
        return (
          <div className={sheetStyles.itemImgWrapper}>
            <Image src={currentImageUrl || ''} alt="" classes={cn(sheetStyles.packageImage, previewImageStyles.img, previewImageStyles.responsive)} />
            <div className={currentClassNameornament}>
              <PreviewImage
                isResponsive
                isPreviewHidden={false}
                actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                foregroundUrl={sheet.pose.watermarkUrl || sheet.addon.poseSelection || sheet.pose.imageUrl}
                backgroundUrl={backgroundForSheet(sheet)}
              />
            </div>
          </div>
        )
        case 'gradannouncement':
          return (
            <div className={sheetStyles.itemImgWrapper}>
              <SchoolAnnouncementThumbnail
                poseUrl={sheet.pose?.imageUrl}
                fallbackSrc={blackImage}
                classes={cn(sheetStyles.packageImage, previewImageStyles.img, previewImageStyles.responsive)}
              />
              <div className={sheetStyles.gradannouncement}>
                <PreviewImage
                  isResponsive
                  isPreviewHidden={false}
                  actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                  foregroundUrl={sheet.pose.watermarkUrl || sheet.addon.poseSelection || sheet.pose.imageUrl}
                  backgroundUrl={backgroundForSheet(sheet)}
                />
              </div>
            </div>
          )
          case   'gradannouncementregular':
            
            return (
              <div className={sheetStyles.itemImgWrapper}>
                <Image 
                    src={currentImageUrl || ''} 
                    alt="" 
                    classes={cn(sheetStyles.packageImage, previewImageStyles.img, previewImageStyles.responsive)} 
                  />
                  
                <div className={sheetStyles.gradannouncementregular}>
                  <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                    foregroundUrl={sheet.pose.watermarkUrl || sheet.addon.poseSelection || sheet.pose.imageUrl}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
                </div>
              </div>
            )
          case   'gradbrown':
            
            return (
              <div className={sheetStyles.itemImgWrapper}>
                <Image 
                    src={currentImageUrl || ''} 
                    alt="" 
                    classes={cn(sheetStyles.packageImage, previewImageStyles.img, previewImageStyles.responsive)} 
                  />
                  
                <div className={sheetStyles.gradbrown}>
                  <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                    foregroundUrl={sheet.pose.watermarkUrl || sheet.addon.poseSelection || sheet.pose.imageUrl}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
                </div>
              </div>
            )
            case   'gradplaid':
            
            return (
              <div className={sheetStyles.itemImgWrapper}>
                <Image 
                    src={currentImageUrl || ''} 
                    alt="" 
                    classes={cn(sheetStyles.packageImage, previewImageStyles.img, previewImageStyles.responsive)} 
                  />
                  
                <div className={sheetStyles.gradplaid}>
                  <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={sheet.pose.watermarkUrl || sheet.addon.poseSelection || sheet.pose.imageUrl}
                    foregroundUrl= {cursiveForeground}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
                </div>
              </div>
            )
            case 'gradcursive':
            return (
              <div className={sheetStyles.itemImgWrapper}>
                <Image
                  src={CURSIVE_BASE_URL}
                  alt=""
                  classes={cn(sheetStyles.packageImage, previewImageStyles.img, previewImageStyles.responsive)}
                />
                <div className={sheetStyles.gradcursive}>
                  <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={cursiveForeground}
                    foregroundUrl={sheet.pose.watermarkUrl || sheet.addon.poseSelection || sheet.pose.imageUrl}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
                </div>
              </div>
            )
            case   'gradclassicvert':
            
            return (
              <div className={sheetStyles.itemImgWrapper}>
                <Image 
                    src={currentImageUrl || ''} 
                    alt="" 
                    classes={cn(sheetStyles.packageImage, previewImageStyles.img, previewImageStyles.responsive)} 
                  />
                  
                <div className={sheetStyles.gradclassicvert}>
                  <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                    foregroundUrl={sheet.pose.watermarkUrl || sheet.addon.poseSelection || sheet.pose.imageUrl}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
                </div>
              </div>
            )
      case 'card':
        return cardPlaceholder;
      case 'keychain':
        return (
          <div className={sheetStyles.itemImgWrapper}>
            <Image src={currentImageUrl || ''} alt="" classes={cn(sheetStyles.packageImage, previewImageStyles.img, previewImageStyles.responsive)} />
            <div className={currentClassNameposeOneKeychain}>
              <PreviewImage
                isResponsive
                backgroundClassName={sheetStyles.keychainPreview}
                isPreviewHidden={false}
                actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                backgroundUrl={sheet.background ? sheet.background.imageUrl : undefined}
              />
            </div>
          </div>
        )
      case 'magnet':
        return (
          <div className={sheetStyles.itemImgWrapper}>
            <Image src={currentImageUrl || ''} alt="" classes={cn(sheetStyles.packageImage, previewImageStyles.img, previewImageStyles.responsive)} />
            <div className={currentClassName}>
              <PreviewImage
                isResponsive
                isPreviewHidden={false}
                actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                backgroundUrl={sheet.background ? sheet.background.imageUrl : undefined}
              />
            </div>
            <div className={currentClassNameposeTwoMagnet}>
              <PreviewImage
                isResponsive
                isPreviewHidden={false}
                actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                backgroundUrl={sheet.background ? sheet.background.imageUrl : undefined}
              />
            </div>
          </div>
        );
      // ⚠️ THE CART AND THE PACKAGE BUILDERS. This is a SECOND renderer, and a
      // variant added only to Item.jsx looks right on the shelf and loses the
      // photo here -- the Desk Plaque proved it (2026-09-29).
      case 'calendarweek':
        return (
          sheet.addon && (
            <div className={sheetStyles.itemImgWrapper}>
              <Image src={currentImageUrl || ''} alt="" classes={cn(sheetStyles.packageImage, previewImageStyles.img, previewImageStyles.responsive)} />
              <div className={currentClassNamecalendarweek}>
                <PreviewImage
                  isResponsive
                  isPreviewHidden={false}
                  actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                  foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                  backgroundUrl={backgroundForSheet(sheet)}
                />
              </div>
            </div>
          )
        );
      case 'calendar':
        return (
          sheet.addon && (
            <div className={sheetStyles.itemImgWrapper}>
              <Image src={currentImageUrl || ''} alt="" classes={cn(sheetStyles.packageImage, previewImageStyles.img, previewImageStyles.responsive)} />
              <div className={currentClassNamecalendar}>
                <PreviewImage
                  isResponsive
                  isPreviewHidden={false}
                  actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                  foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                  backgroundUrl={backgroundForSheet(sheet)}
                />
              </div>
            </div>
          )
        );
        case 'eightbytenG':
          return (
            sheet.addon && (
              <div className={sheetStyles.itemImgWrapper}>
                <Image src={currentImageUrl || ''} alt="" classes={cn(sheetStyles.packageImage, previewImageStyles.img, previewImageStyles.responsive)} />
                <div className={currentClassNameeightbytenG}>
                  
                  <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                    foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
                </div>
              </div>
            )
          );
        // A DIGITAL FILE IS NOT A PRINT -- same reasoning as the grid card in
        // Holiday/Builder/Item. No product mockup to composite into, and no
        // product image to fall back on, so the portrait is drawn on its own.
        case 'digitalfile':
          return (
            sheet.addon && (
              <div className={sheetStyles.itemImgWrapper}>
                <div className={sheetStyles.digitalfile}>
                  <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                    foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
                </div>
              </div>
            )
          );
          case 'coffeecup':
          return (
            sheet.addon && (
              <div className={sheetStyles.itemImgWrapper}>
                <Image src={currentImageUrl || ''} alt="" classes={cn(sheetStyles.packageImage, previewImageStyles.img, previewImageStyles.responsive)} />
                <div className={currentClassNamecoffeecup}>
                  
                  <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                    foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
                </div>
              </div>
            )
          );
        case 'fivebyseven':
          return (
            sheet.addon && (
              <div className={sheetStyles.itemImgWrapper}>
                <Image src={currentImageUrl || ''} alt="" classes={cn(sheetStyles.packageImage, previewImageStyles.img, previewImageStyles.responsive)} />
                <div className={currentClassNameposeOnefivebyseven}>
                  <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                    foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
                </div>
                <div className={currentClassNameposeTwofivebyseven}>
                  <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                    foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
                </div>
              </div>
            )
          );
        case 'threebyfive':
          return (
            sheet.addon && (
              <div className={sheetStyles.itemImgWrapper}>
                <Image src={currentImageUrl || ''} alt="" classes={cn(sheetStyles.packageImage, previewImageStyles.img, previewImageStyles.responsive)} />
                <div className={currentClassNameposeOnethreebyfive}>
                  <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                    foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
                </div>
                <div className={currentClassNameposeTwothreebyfive}>
                  <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                    foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
                </div>
                <div className={currentClassNameposeThreethreebyfive}>
                  <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                    foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
                </div>
                <div className={currentClassNameposeFourthreebyfive}>
                  <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                    foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
                </div>
              </div>
            )
          );
        case 'wallets':
          return (
            sheet.addon && (
            <div className={sheetStyles.itemImgWrapper}>
              <Image src={currentImageUrl || ''} alt="" classes={cn(styles.packageImage, previewImageStyles.img, previewImageStyles.responsive)} />
              
              <div className={currentClassNameposeOneWallet}>
                <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                    foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
                
              </div>
              <div className={currentClassNameposeTwoWallet}>
                <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                    foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
              </div>
              <div className={currentClassNameposeThreeWallet}>
                <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                    foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
              </div>
              <div className={currentClassNameposeFourWallet}>
                <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                    foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
              </div>

              <div className={currentClassNameposeFiveWallet}>
                <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                    foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
              </div>
              <div className={currentClassNameposeSixWallet}>
                <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                    foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
              </div>
              <div className={currentClassNameposeSevenWallet}>
                <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                    foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
              </div>
              <div className={currentClassNameposeEightWallet}>
                <PreviewImage
                    isResponsive
                    isPreviewHidden={false}
                    actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                    foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                    backgroundUrl={backgroundForSheet(sheet)}
                  />
              </div>
            </div>
          )
          );
      case 'plaque':
        return (
          <div className={sheetStyles.itemImgWrapper}>
            <Image src={currentImageUrl || ''} alt="" classes={cn(sheetStyles.packageImage, previewImageStyles.img, previewImageStyles.responsive)} />
            <div className={currentClassNameposeOnePlaque}>
              <PreviewImage
                isResponsive
                isPreviewHidden={false}
                actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
                foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
                backgroundUrl={sheet.background ? sheet.background.imageUrl : undefined}
              />
            </div>
          </div>
        );
      default:
        // Same rule as the grid card (Holiday/Builder/Item): a css_name no preview
        // knows draws the add-on's own product image rather than nothing, so the
        // customer sees the product they're buying instead of an empty box.
        reportUnknownAddonVariant(sheet.addon, getImageTypeClassname);

        return (
          <div className={sheetStyles.itemImgWrapper}>
            <Image src={currentImageUrl || ''} alt="" classes={cn(sheetStyles.packageImage, previewImageStyles.img, previewImageStyles.responsive)} />
          </div>
        );
    }
  }

  const backgroundForSheet = (sheet) => {
    //console.log(sheet);
    if (sheet.addon) {
      return sheet.addon.backgroundSelection && sheet.background ? sheet.background.imageUrl : undefined
    }
    return sheet.background?.imageUrl
  }
  const comboContainerStyle = {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
    // Remove fixed height, let content determine height
  };

  const renderPreview = () => {
    const child = renderImageComponent();

    if (sheet.imageType.classname === 'dont do till I fix horizontal background plaque') {
      return (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          {child}
          {inPreview && (
            <div className={styles.sheetItem}>
              <img alt="Back of Ornament" src={sheet.addon.backImageUrl} style={{ maxWidth: '100%' }} />
            </div>
          )}
        </div>
      );
    }

    return child;
  }

  if (sheet.addon?.isHoliday) {
    return (
      <div 
      id="displayable-sheet"  // Add ID here
      className={cn('sheetsWrapper', styles.sheetsWrapper, styles[`numItems${numImgsPerSheet}`], `numItems${numImgsPerSheet}`, className, inPreview ? 'inPreview' : 'notInPreview', getImageTypeClassname, styles[getImageTypeClassname])}
    >
      <div className={sheetStyles.item}>
          {renderPreview()}
        </div>

        {children}
      </div>
    );
  }

// The (1) 5x7 (2) 3x5 combo sheet. A CSS grid lays the three prints out so the 5x7 spans
// two tracks and the columns/rows stay height-aligned automatically -- no fixed pixels, so
// it is responsive on phone and desktop. Orientation flips the arrangement: the prints
// follow the photo (portrait pose -> portrait prints; landscape pose -> landscape prints).
if (getImageTypeClassname === 'fivebyseven2threebyfive') {
  const comboForegroundUrl = sheet.pose?.watermarkUrl || sheet.pose?.imageUrl;
  const comboBackgroundUrl = backgroundForSheet(sheet);
  // Undefined (still measuring) falls through to the vertical layout, the common case.
  const isLandscapePose = poseOrientation === ORIENTATION.LANDSCAPE;

  // One composited print filling its grid cell. The grid sizes the cell; the image
  // object-covers to fill it (foreground AND background), so the photo fills the print
  // instead of leaving the backdrop showing -- exactly how a real print crops to size.
  const comboPrint = (gridArea) => (
    <div style={{ gridArea, position: 'relative', overflow: 'hidden' }}>
      <PreviewImage
        isResponsive={false}
        isPreviewHidden={false}
        actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
        foregroundUrl={comboForegroundUrl}
        backgroundUrl={comboBackgroundUrl}
        containerClass="relative z-[1] w-full h-full overflow-hidden [&_img]:w-full [&_img]:h-full [&_img]:object-cover"
      />
    </div>
  );

  // Vertical: 5x7 (portrait) on the left spanning both rows, two 3.5x5 (portrait) stacked on
  // the right. Horizontal: 5x7 (landscape) across the top, two 3.5x5 (landscape) side by side
  // beneath. A 3.5x5 is 5:7 -- the SAME proportion as a 5x7 -- so EVERY cell is 5:7 (or 7:5),
  // just at two sizes. The 2:1 tracks make the big cell exactly twice the small in the shared
  // dimension, and aspect-ratio (15:14 / 14:15) makes each cell land on 5:7 with the spanning
  // 5x7 aligning the edges.
  const gridStyle = isLandscapePose
    ? {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gridTemplateRows: '2fr 1fr',
      gridTemplateAreas: '"big big" "small1 small2"',
      aspectRatio: '14 / 15',
      gap: '3px',
    }
    : {
      display: 'grid',
      gridTemplateColumns: '2fr 1fr',
      gridTemplateRows: '1fr 1fr',
      gridTemplateAreas: '"big small1" "big small2"',
      aspectRatio: '15 / 14',
      gap: '3px',
    };

  return (
    <div
      id="displayable-sheet"
      className={cn('sheetsWrapper', styles.sheetsWrapper, styles[`numItems3`], `numItems3`, className, inPreview ? 'inPreview' : 'notInPreview', getImageTypeClassname, styles[getImageTypeClassname])}
      style={{ width: '100%' }}
    >
      <div className={sheetStyles.item}>
        <div className={sheetStyles.itemImgWrapper} style={{ width: '80%', margin: '0 auto', ...gridStyle }}>
          {comboPrint('big')}
          {comboPrint('small1')}
          {comboPrint('small2')}
        </div>
      </div>
      {children}
    </div>
  );
}

// Default sheet layout (wallets, 5x7, 3x5, 8x10, ...). Recognized print sheets are forced to
// their true paper proportion so a landscape pose can't render as a skinny print: every
// non-8x10 print is the 5x7 shape -- 5:7 portrait / 7:5 landscape -- and ROTATES WITH THE POSE
// (a horizontal pose prints a horizontal wallet); the 8x10 is 4:5 / 5:4. Other sheet types are
// left as-is (printRatio null).
//
// [w, h] of the print. printColumns matches the old per-row counts (widthPerItem 100/50/50/25
// -> 1/2/2/4 columns for 8x10 / 5x7 / 3x5 / wallets).
let printRatio = null;
if (nameWithoutNum.includes('8x10')) {
  printRatio = poseOrientation === ORIENTATION.LANDSCAPE ? [5, 4] : [4, 5];
} else if (nameWithoutNum.includes('wallet') || nameWithoutNum.includes('5x7') || nameWithoutNum.includes('3x5')) {
  printRatio = poseOrientation === ORIENTATION.LANDSCAPE ? [7, 5] : [5, 7];
}
// Recognized print sheets render as a CSS grid with the whole sheet fitted into a bounding box.
// The grid TRANSPOSES for a landscape pose so the sheet stays a sensible print area instead of a
// skinny strip: 8 wallets are 4x2 for a portrait pose (a 10:7 sheet) but 2x4 for a landscape
// pose (a 7:10 sheet), NOT 4x2 landscape (a 14:5 strip). The container gets a definite width and
// the sheet's own aspect-ratio, so each 1fr cell lands on the exact print proportion (printRatio)
// and the image object-covers to fill it.
if (printRatio) {
  const portraitCols = Math.max(1, Math.round(100 / widthPerItem));
  const portraitRows = Math.ceil(numImgsPerSheet / portraitCols);
  // Landscape transposes rows<->columns; the sheet keeps the same paper, just rotated.
  const printColumns = poseOrientation === ORIENTATION.LANDSCAPE ? portraitRows : portraitCols;
  const printRows = Math.ceil(numImgsPerSheet / printColumns);

  // Overall sheet proportions = (columns x printW) : (rows x printH). Fit it inside MAX_W x
  // MAX_H preserving that ratio, so a portrait sheet isn't too tall and a landscape one isn't
  // too wide. width:min(100%, fitW) keeps it responsive on phones.
  const sheetAspectW = printColumns * printRatio[0];
  const sheetAspectH = printRows * printRatio[1];
  const MAX_W = 480;
  const MAX_H = 440;
  const fitW = sheetAspectW / sheetAspectH >= MAX_W / MAX_H
    ? MAX_W
    : Math.round(MAX_H * (sheetAspectW / sheetAspectH));

  return (
    <div
      id="displayable-sheet"
      className={cn('sheetsWrapper', styles.sheetsWrapper, styles[`numItems${numImgsPerSheet}`], `numItems${numImgsPerSheet}`, className, inPreview ? 'inPreview' : 'notInPreview', getImageTypeClassname, styles[getImageTypeClassname])}
      style={{ width: `min(100%, ${fitW}px)`, margin: '0 auto' }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${printColumns}, 1fr)`,
          gridTemplateRows: `repeat(${printRows}, 1fr)`,
          gap: '3px',
          width: '100%',
          aspectRatio: `${sheetAspectW} / ${sheetAspectH}`,
        }}
      >
        {new Array(numImgsPerSheet).fill(null).map((_, i) => (
          <div
            key={`${sheet.poseId}${sheet.imageTypeId}${sheet.backgroundId}${i}`}
            style={{ position: 'relative', overflow: 'hidden' }}
          >
            <PreviewImage
              isResponsive={false}
              isPreviewHidden={false}
              actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
              foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
              backgroundUrl={backgroundForSheet(sheet)}
              containerClass="relative z-[1] w-full h-full overflow-hidden [&_img]:w-full [&_img]:h-full [&_img]:object-cover"
            />
          </div>
        ))}
      </div>
      {children}
    </div>
  );
}

// Every other sheet type: unchanged flex layout at the image's natural aspect.
return (
  <div
    id="displayable-sheet"
    className={cn('sheetsWrapper', styles.sheetsWrapper, styles[`numItems${numImgsPerSheet}`], `numItems${numImgsPerSheet}`, className, inPreview ? 'inPreview' : 'notInPreview', getImageTypeClassname, styles[getImageTypeClassname])}
  >
    {new Array(numImgsPerSheet).fill(null).map((_, i) => (
      <div
        className={styles.sheetItem}
        key={`${sheet.poseId}${sheet.imageTypeId}${sheet.backgroundId}${i}`}
        style={{ width: `${widthPerItem}%` }}
      >
        <PreviewImage
          isResponsive={inBuilder}
          isPreviewHidden={false}
          actualForegroundUrl={sheet.foreground?.imageUrl} nameForeground={sheet.foreground} nameFirstName={customer.currentStudent?.firstName}
          foregroundUrl={sheet.pose.watermarkUrl || sheet.pose.imageUrl}
          backgroundUrl={backgroundForSheet(sheet)}
        />
      </div>
    ))}
    {children}
  </div>
);

// And at the very end of your component:
}

DisplayableSheet.defaultProps = {
  className: '',
};

DisplayableSheet.propTypes = {
  className: pt.string,
  sheet: SheetPropType.isRequired,
};
